import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { waitForSeconds } from "../../../helper";
import info from "../../../data/enneagramme.json";
import Chart from "chart.js/auto";
import { drawRadarChart, restartQuiz } from "../formHelper";

export default function CompletedEnneagramme({}) {
  const navigate = useNavigate();
  const [results, setResults] = useState();
  const [presented, setPresented] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let res = formatReponsesEnneagramme(JSON.parse(localStorage.getItem("reponses")));
    setResults(res);
  }, []);

  useEffect(() => {
    if (results && !presented) {
      setPresented(true);
      showReponses();
    }
  }, [results]);

  async function showReponses() {
    await waitForSeconds(0.2);
    document.getElementById("title").classList.remove("opacity-0");

    await waitForSeconds(1);
    document.getElementById("subtitle").classList.remove("opacity-0");
    document.getElementById("subtitle").classList.add("mt-5");

    await waitForSeconds(0.5);
    document.getElementById("results_card").classList.remove("opacity-0");
    document.getElementById("results_card").classList.add("mt-5");
    await waitForSeconds(1);
    drawRadarChart("parentRadarChart", [...results.map((e) => e.score)], [...results.map((e) => info.results.labels[e.group])]);

    document.getElementById("button_restart").classList.remove("opacity-0");
    setLoading(false);
  }

  return (
    <div className="flex flex-col justify-center items-center text-center pb-20 p-2 sm:p-5">
      <img id="logo" src="/images/Page_résultats.png" className="mx-auto h-52 md:h-64 transition-all duration-1000 ease-out" alt="logo" />
      <h1 id="title" className="opacity-0 transition-all duration-1000 ease-out lg:text-5xl">
        Merci d'avoir rempli le formulaire
      </h1>
      {/*<p id="subtitle" className="opacity-0 transition-all duration-700 ease-out lg:text-xl">*/}
      {/*  Voici vos résultats*/}
      {/*</p>*/}
      {/*{results && (*/}
      {/*  <div*/}
      {/*    id="results_card"*/}
      {/*    className="opacity-0 transition-all duration-1000 ease-out w-full h-full max-w-4xl bg-white flex flex-col space-y-5 p-5 rounded-lg shadow-xl"*/}
      {/*  >*/}
      {/*    {loading && <p>Chargement des résultats...</p>}*/}
      {/*    <div id="parentRadarChart" />*/}
      {/*  </div>*/}
      {/*)}*/}
      <button
        id="button_restart"
        onClick={() => restartQuiz(navigate)}
        className="font-semibold opacity-0 transition-all duration-700 ease-out border flex items-center space-x-1 mt-20 border-palette-green mx-auto text-palette-green rounded-lg px-4 py-1.5"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
          />
        </svg>
        <p>Refaire le quiz</p>
      </button>
    </div>
  );
}

export function formatReponsesEnneagramme(reponses) {
  let res = [];
  for (let index = 0; index < reponses.length; index++) {
    const group = reponses[index];
    for (let i = 0; i < group.length; i++) {
      const reponse = group[i];
      if (!res.find((e) => e.group === reponse.scoreGroup)) res.push({ group: reponse.scoreGroup, score: reponse.score });
      else res.find((e) => e.group === reponse.scoreGroup).score += reponse.score;
    }
  }
  let somme = res.reduce((a, b) => {
    return { score: a.score + b.score };
  }).score;

  for (let index = 0; index < res.length; index++) {
    res[index].score = Math.round((res[index].score / somme) * 100);
  }

  res.sort((a, b) => a.group - b.group);
  return res;
}
